import { render, staticRenderFns } from "./MachineBubbles.vue?vue&type=template&id=0f9e1228&scoped=true"
import script from "./MachineBubbles.vue?vue&type=script&lang=js"
export * from "./MachineBubbles.vue?vue&type=script&lang=js"
import style0 from "./MachineBubbles.vue?vue&type=style&index=0&id=0f9e1228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e1228",
  null
  
)

export default component.exports